import {ajax,getMessage,setMessage} from './common.js'
import {Toast} from 'mint-ui'
import bus from '../../../config/bus.js'

localStorage.setItem("platkey","zhaobi");

function inputFocus(val,that){
  console.log(val);
  var _this=that;
  if(val=='phoneInput'){
    if(_this.areaCode==86){
      _this.phoneInput=true;
    }
    else{
      _this.phoneInput=false;
    }
  }
  else{
    _this[val]=true;
    // if(_this.tab==1){
    //   _this[val]=true;
    // }
    // else{
    //   _this[val]=false;
    // }
  }
};

/*拆分input输入值*/
function separateNum(val,ref,that,type){
  var _this=that;
  if(val=='mobileInput'&&type=='logReg'&&_this.boxShow!=""){
    _this.goOrigin('modify');
  }
  let array=_this.userParam[val].toString().split('');
  if(val=='mobileInput'){
    // _this.pwdArray=array;
    if(_this.areaCode==86){
      if(array.length>10){
        _this.$refs[ref].blur();
      }
      if(array.length==11){
        _this.showCodeBox();
      }
    }
  }
  else{
    // _this.codeArray=array;
    if(array.length>3){
      _this.$nextTick(()=>{
        _this.$refs[ref].blur();
      })
    }
  }
  // var array=_this.userParam[val].toString().split('');
  // if(val=='mobileInput'){
  //   _this.pwdArray=array;
  // }
  // else{
  //   _this.codeArray=array;
  // }
  // if(array.length>10){
  //   _this.$refs[ref].blur();
  // }
  // if(array.length==11){
  //   _this.showCodeBox();
  // }
  // if(array.length==0){
  //   _this.showCodeBox();
  // }
};

/* 快速注册 */
function quickReg(_this,param,paramLogin){
  ajax(_this,_this.extendApi.quickReg,param,(data)=>{
    if(data.code==200){
      _this.Toast("注册成功");
      quickLogin(_this,paramLogin);
    }
    else{
      _this.Toast(data.message);
    }
  },'post');
};

/* 快速登录 */
function quickLogin(_this,param){
  ajax(_this,_this.extendApi.quickLogin,param,(data)=>{
    if(data.code==200){
      _this.Toast("登录成功");
      data=data.data;
      setMessage('token',data.access_token);
      // sessionStorage.setItem('token',data.access_token);
      sessionStorage.removeItem("setParam");
      localStorage.setItem('userid',data.userid);
      _this.$router.push({path:'/index'});
      bus.$emit("bankChange");
    }
    else{
      _this.Toast(data.message);
    }
  },'post');
};

/*注册*/
function register(val,that){
  console.log('register');
  return;
  if(this.rePwd==""){
    this.Toast("请先输入密码");
    return false;
  }
  let param={};
  if(this.tab==1){
    param={
      mobile:this.reUser,
      password:this.rePwd,
      code:this.reCode,
      checkmethod:"data",
      type:"sms",
      area:this.areaCode,
      invite_code:this.invite_code
    };
  }
  else if(this.tab==2){
    let name=$("#login-name").val();
    param={
      email:name,
      password:this.rePwd,
      code:this.reCode,
      checkmethod:"data",
      type:"email",
      invite_code:this.invite_code
    };
  }
  var that=this;
  this.redelay=0;
  // this.popupVisible2=true;
  ajax(this,this.extendApi.userReg,param,(data)=>{
    // this.popupVisible2=false;
    this.redelay=1;
    if(data.code==200){
      this.popupVisible2=false;
      if(this.tab==1){
        this.login(this.reUser,this.rePwd,this.areaCode);
      }
      if(this.tab==2){
        this.login(name,this.rePwd);
      }
    }
    else{
      Toast(data.message);
    }
  },"post");
}

/*手机国家获取*/
function countryCheck(_this){
  let param={
    type:"code",
  };
  _this.countryslot[0].values=[];
  ajax(_this,_this.extendApi.countryList,param,(data)=>{
    if(data.code==200){
      for(let i=0;i<data.data.length;i++){
        _this.countryslot[0].values.push(data.data[i]);
      }
    }
  },"GET");
};

function resetPwd(_this,param){
  // if(_this.rePwd0==''){
  //   _this.Toast("请先输入新密码");
  //   return false;
  // }
  // if(_this.rePwd==''){
  //   _this.Toast("请重复一遍新密码");
  //   return false;
  // }
  // if(_this.rePwd0!=_this.rePwd){
  //   _this.Toast("两次输入的密码不同");
  //   return false;
  // }
  // let arr=["code","sms","email"];
  // let type=arr[_this.tab];
  // var postdata = {
  //   resettoken:_this.code,
  //   password:_this.rePwd0,
  //   password2:_this.rePwd0,
  //   os:"mobile",
  //   type:type,
  // };
  _this.popupVisible2=true;
  ajax(_this,_this.extendApi.newResetPwd,param,(data)=>{
    _this.popupVisible2=false;
    if(data.code==200){
      // _this.Toast('修改密码成功,即将登录');
      // setTimeout(function(){
      //   _this.$router.push({path:'/login'});
      // },1000);
      param.redirect_uri="https://zhaobi.com";
      param.logintype='password';
      quickLogin(_this,param);
    }
    else{
      _this.Toast(data.message);
    }
  },'post');
}

// function getArea(val,_this){
//   _this.pop2=false;
//   _this.areaCode=val;
// };

function addJs(src,_this){
  let dom1=document.createElement("script");
  dom1.src=src;
  document.getElementsByTagName("body")[0].appendChild(dom1);
  dom1.onload=()=>{
    var capOption = {callback:_this.cbfn, showHeader:true,type:"popup"};
    capInit(document.getElementById("TCaptcha"), capOption);
  }
};

/* 图形验证码 */
function patternCode(src,_this){
  _this.patternVerification=true;
  addJs(src,_this);
  // var capOption = {callback:this.cbfn, showHeader:true,type:"popup"};
  // capInit(document.getElementById("TCaptcha"), capOption);

};

var speechVerification=function(that,param,loadKey){

  that[loadKey]=true;
  that.newCodeType="voice";
  /*测试倒计时，不真正发送短信*/
  // that.voiceState=false;
  // that[loadKey]=false;
  // that.reltime=setInterval(()=>{
  //   that.secondNum--;
  //   that[loadKey]=false;
  //   if(that.secondNum==50){
  //     clearInterval(that.reltime);
  //     that.voiceState=true;
  //     that.secondNum=60;

  //   }
  // }, 1000);
  // if(!param.codetype){
  //   param.codetype="validate";
  // }
  // if(!param.area){
  //   param.area=localStorage.getItem("area");
  // }
  // return;
  /*end*/

  if(!param.area){
    param.area=localStorage.getItem("area");
  }
  if(!param.codetype){
    param.codetype="validate";
  }
  param.platkey=localStorage.getItem("platKey");
  ajax(that,that.extendApi.newVoice,param,(data)=>{
    that[loadKey]=false;
    if(data.code==200){
      if(data.data.isShow==0){
        that.voiceState=false;
        clearInterval(that.reltime);
        that.reltime=setInterval(()=>{
          that.secondNum--;
          if(that.secondNum==0){
            clearInterval(that.reltime);
            that.voiceState=true;
            that.secondNum=60;

          }
        }, 1000);
      }
      if(data.data.isShow==1){
        patternCode(data.data.data.jsUrl,that);
        that.patternParam.businessId=data.data.data.businessId;
      }
    }
    else{
      Toast(data.message);
    }
  },"POST");
};


var setEmail=function(that,codetype,vparam,email,success,ticket,businessId){
  var token = getMessage('token');
  vparam=vparam.replace(/FzmRandom/,"FzmRandom4");

  /*测试倒计时，不真正发送短信*/
  // that.Toast('发送成功');
  // that.codestate=1;
  // that.secondNum=60;
  // clearInterval(that.reltime);
  // that.reltime=setInterval(function(){
  //   that.secondNum--;
  //   if(that.secondNum==55){
  //     clearInterval(that.reltime);
  //     that.codestate=0;
  //     that.secondNum=60;
  //   }
  // }, 1000);
  // return;
  /*end*/

  var codeDate = {
    platkey:localStorage.getItem("platKey"),
    codetype: codetype,
    param: vparam,
    email:email,
    ticket:ticket,
    businessId:businessId
  };
  codeDate=that.querystring.stringify(codeDate);
  that.axios({
    method:'post',
    url:that.extendApi.newMail,
    headers: {
      Authorization: 'Bearer ' + token,
    },
    data:codeDate,
  }).then((response) => {
    var data=response.data;
    if(typeof(success)=='function'){
      success(data);
    }
    if(data.code==200){
      if(data.data.isShow==0){
        that.Toast('发送成功');
        that.codestate=1;
        that.secondNum=60;
        that.gid=data.data.gid;
        clearInterval(that.reltime);
        that.reltime=setInterval(function(){
          that.secondNum--;
          if(that.secondNum==0){
            clearInterval(that.reltime);
            that.codestate=0;
            that.secondNum=60;
          }
        }, 1000);
      }
      if(data.data.isShow==1){
        patternCode(data.data.data.jsUrl,that);
        that.patternParam.businessId=data.data.data.businessId;
      }
    }
    else{
      Toast(data.message);
    }
  }).catch(function(response) {
    console.log(response);
  })
};

function setCode(that,codetype,vparam,mobile,success,ticket,businessId){
  var token = getMessage('token');
  that.voiceShow=false;
  vparam=vparam.replace(/FzmRandom/,"FzmRandom4");


  /*测试倒计时，不真正发送短信*/
  that.codestate=1;
  that.secondNum=60;
  that.popupVisible2=false;
  that.popupVisible3=false;
  clearInterval(that.reltime);
  that.reltime=setInterval(function(){
    that.secondNum--;
    if(that.secondNum==50){
      that.voiceShow=true;
      clearInterval(that.reltime);
      that.codestate=0;
      that.secondNum=60;
    }
  }, 1000);
  return;
  /*end*/

  getsmsTpl(that,function(data){
    if(typeof(success)=='function'){
      success(data);
    }
    if(data.code==200){
      if(data.data.isShow==0){
        that.codestate=1;
        that.secondNum=60;

        that.gid=data.data.gid;
        clearInterval(that.reltime);
        that.reltime=setInterval(function(){
          that.secondNum--;
          if(that.secondNum==0){
            clearInterval(that.reltime);
            that.codestate=0;
            that.secondNum=60;
            that.voiceShow=true;
          }
        }, 1000);
      }
      if(data.data.isShow==1){
        patternCode(data.data.data.jsUrl,that);
        that.patternParam.businessId=data.data.data.businessId;
      }
    }
    else{
      Toast(data.message);
    }
  },codetype,mobile,vparam,ticket,businessId);
};

function getsmsTpl(that,success,codetype,mobile,vparam,ticket,businessId){
  var mobile=mobile;
  var token = getMessage('token');
  var area=that.areaCode||localStorage.getItem('area');
  var vparam = vparam || "FzmUid|FzmRandom4";
  // var codeDate = {
  //     codetype: codetype,
  //     param: vparam,
  //     area:area,
  //     mobile:mobile,
  // };
  var codeDate = {
    platkey:localStorage.getItem("platKey"),
    codetype:codetype,
    param: vparam,
    area:area,
    mobile:mobile,
    ticket:ticket,
    businessId:businessId,
  };
  codeDate=that.querystring.stringify(codeDate);
  that.axios({
    method:'post',
    url:that.extendApi.newSms,
    headers: {
      Authorization: 'Bearer ' + token,
    },
    data:codeDate,
  }).then((response) => {
    if(typeof(success)=='function'){
      success(response.data);
    }
  }).catch(function(response) {
    console.log(response);
  })
}

export{
  inputFocus,
  separateNum,
  countryCheck,
  resetPwd,
  quickReg,
  quickLogin,
  setCode,
  setEmail,
  patternCode,
  speechVerification
  // register
}



// WEBPACK FOOTER //
// ./src/assets/js/login-common.js